<template>
  <v-app id="inspire">
    <DemoGuide />
    <v-snackbar v-model="demoToast.show" :timeout="2000" top right>
      {{ demoToast.text }}
    </v-snackbar>
    <v-snackbar v-if="progressMessage" timeout="-1" v-model="progressMessage" color="info">
      {{ progressMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="progressMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-if="progressMessageError" v-model="progressMessageError" color="error">
      {{ progressMessageError }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="progressMessageError = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-main class="ma-0" v-if="checkExcludedRoutes && !charge">
      <router-view :key="$route.fullPath"></router-view>
    </v-main>

    <div class="ma-2 side-menu" v-else-if="!charge">
      <v-navigation-drawer
        class="menu-drawer"
        v-if="isAuthenticated && !isCreateAccount"
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
      >
        <div class="ml-4">
          <search
            v-if="!isCreateAccount && !customerId && !$vuetify.breakpoint.lgAndUp && !hideSearch && !$root.isHost"
          ></search>
        </div>

        <v-switch v-if="!$vuetify.breakpoint.lgAndUp" class="ml-2" label="Dark mode" v-model="darkMode"></v-switch>

        <Chat v-if="!$vuetify.breakpoint.lgAndUp && !noChat && !customerId" />

        <side-menu
          :resentTabs="resentTabs"
          :allowedRoutes="allowedRoutes"
          :removedRoutes="removedRoutes"
          :items="items"
          ref="sideMenu"
          :key="menuKey"
          v-if="items.length"
        ></side-menu>
      </v-navigation-drawer>
      <v-btn v-if="showInstallPrompt" color="info" @click="installPWA">Install MoverAI App</v-btn>

      <v-app-bar v-if="isAuthenticated && !hideAppBar" :clipped-left="$vuetify.breakpoint.lgAndUp" app>
        <a v-if="!customerId" href="/#/dashboard">
          <v-img v-if="!$vuetify.breakpoint.mdAndUp" style="width: 120px" src="logo_new.png" alt="moverai"></v-img
        ></a>
        <v-toolbar-title class="nav-blue ml-n4 pa-4">
          <a v-if="!customerId" href="/#/dashboard">
            <v-img v-if="$vuetify.breakpoint.mdAndUp" style="width: 180px" src="logo_new.png" alt="moverai"></v-img
          ></a>
          <div v-else>
            <v-img v-if="$vuetify.breakpoint.mdAndUp" style="width: 180px" :src="$root.logo" alt="moverai"></v-img>
          </div>
          <div class="pr-4 version">v {{ version }}</div>
        </v-toolbar-title>

        <v-app-bar-nav-icon class="ml-6" @click.stop="drawer = !drawer" v-if="!isCreateAccount"></v-app-bar-nav-icon>
        <v-switch v-if="$vuetify.breakpoint.lgAndUp" class="mt-6 ml-2" label="Dark mode" v-model="darkMode"></v-switch
        ><v-spacer v-if="$vuetify.breakpoint.lgAndUp"></v-spacer>
        <h3 v-if="$vuetify.breakpoint.lgAndUp">
          Welcome {{ store.userData.first_name }} {{ store.userData.last_name }}
        </h3>
        <v-spacer></v-spacer>
        <Chat v-if="$vuetify.breakpoint.lgAndUp && !noChat && !customerId" />
        <v-spacer></v-spacer>
        <search
          v-if="!isCreateAccount && !customerId && $vuetify.breakpoint.mdAndUp && !hideSearch && !$root.isHost"
        ></search>

        <v-btn
          small
          @click="
            $root.addResentTab({
              text: 'New Shipment',
              link: '/shipment/0',
              shipment_id: 0
            })
          "
          class="top-info-line ma-2"
          color="success"
          v-if="!cannotCreateJob && !$root.isHost"
        >
          <v-icon class="ma-0">mdi-plus-circle</v-icon>
          <span class="ma-2" v-if="$vuetify.breakpoint.mdAndUp">
            New Move
          </span>
        </v-btn>
        <!-- <v-btn text @click.stop="aiDrawer = !aiDrawer"
          ><v-icon>mdi-assistant</v-icon>Ask MoverAI</v-btn
        > -->
        <v-btn v-if="!customerId" small text @click.stop="aiDrawer = !aiDrawer" color="pink">
          <v-icon class="ma-2">mdi-assistant</v-icon>
          <span v-if="$vuetify.breakpoint.mdAndUp">{{ aiDrawer ? "Close" : "Ask" }} MoverAI</span>
        </v-btn>
        <v-menu v-if="!isCreateAccount" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="pr-2" icon large v-bind="attrs" v-on="on">
              <v-avatar size="32px" item>
                <v-icon>mdi-account</v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-card class="mx-auto pa-1 login_menu" max-width="280">
            <v-list style="min-width: 140px">
              <v-list-item-group color="primary">
                <v-list-item v-if="store.userData && store.userData.roles">
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>{{ email }}</v-list-item-content>
                </v-list-item>
                <v-list-item v-if="store.userData && store.userData.roles && !customerId">
                  <v-list-item-icon>
                    <v-icon>mdi-account-key</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content v-if="store.userData && store.userData.roles">{{
                    store.userData.roles
                  }}</v-list-item-content>
                </v-list-item>
                <!-- <v-list-item
                  v-if="
                    store.portalData.company_name !== 'emover' &&
                      store.userData.roles.includes('HOST')
                  "
                  @click="toHost"
                >
                  <v-list-item-icon>
                    <v-icon>home</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>To HOST</v-list-item-content>
                </v-list-item> -->

                <v-list-item
                  v-if="store.userData && store.userData.roles && !customerId"
                  @click="signDialog = !signDialog"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-draw-pen</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>Create/Edit Signature</v-list-item-content>
                </v-list-item>
                <v-list-item @click="logout">
                  <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>Logout</v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu>
        <v-btn text @click="logout" v-else>
          <v-icon>mdi-logout</v-icon>
          <span v-if="$vuetify.breakpoint.mdAndUp">Logout</span>
        </v-btn>
        <!-- <template v-slot:extension>

        </template> -->
      </v-app-bar>

      <v-main v-if="isAuthenticated">
        <v-container class="main-container" fluid>
          <v-tabs
            class="main-tabs gradient-background ml-2 "
            v-if="resentTabs.length"
            :key="tabKey"
            v-model="activeTab"
            show-arrows
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="(t, i) in resentTabs" :key="i" :to="t.link">
              <!-- <v-btn class="tab-title" @click="refreshTab(t)" text>{{
              t.text
            }}</v-btn> -->
              <v-icon class="pr-2" v-if="t.icon">{{ t.icon }}</v-icon>
              {{ t.text }}
              <!-- <v-btn icon @click="refreshTab(t, true)" class="ml-2"
              ><v-icon x-small>mdi-reload</v-icon></v-btn
            > -->
              <v-btn icon @click="removeResentTab(i)" class="ml-2">
                <v-icon x-small>mdi-close</v-icon>
              </v-btn>
            </v-tab>
          </v-tabs>

          <keep-alive :exclude="excludeRoutes">
            <router-view
              class="active-view"
              :class="$vuetify.breakpoint.mdAndUp ? 'ma-0' : 'ma-0'"
              v-if="permissionsReady"
              :key="$route.fullPath"
            ></router-view>
          </keep-alive>

          {{ addedClasses }}
        </v-container>
        <v-snackbar v-if="successMessage" v-model="successMessage" :timeout="3000" color="success">
          {{ successMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="successMessage = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <!-- <v-alert
          v-if="successMessage !== '' && successMessage"
          timeout="3000"
          dense
          :value="successMessage"
          type="success"
        >
          {{ successMessage }}
        </v-alert> -->
        <v-alert timeout="3000" dense v-if="errorMessage !== '' && errorMessage" type="error">
          {{ errorMessage }}
        </v-alert>
        <v-snackbar
          class="multi"
          :style="{ 'margin-bottom': calcMargin(i) }"
          v-for="(s, i) in messages"
          :key="i"
          v-model="show"
          :multi-line="true"
          right
          :color="s.color"
          :timeout="timeout"
        >
          <h3>{{ s.title }}</h3>
          {{ s.text }}
          <template v-slot:action="{ attrs }">
            <v-btn v-if="s.link" @click="addResentTab(s.link)" right icon><v-icon>mdi-link</v-icon></v-btn>
            <v-btn v-bind="attrs" right icon @click="hide(i)">
              <v-icon>mdi-close</v-icon>
            </v-btn></template
          >
        </v-snackbar>
      </v-main>
      <Login v-if="!isAuthenticated && !showInstallPrompt"></Login>
      <Confirm ref="confirm"></Confirm>
      <v-pop-up ref="popup"></v-pop-up>
      <!-- <v-alert
      class="alert"
      transition="scale-transition"
      v-model="$store.state.notification.toggle"
      :type="$store.state.notification.notificationType"
      >{{ $store.state.notification.notificationMessage }}
    </v-alert> -->
    </div>
    <div v-else>
      <credit-card></credit-card>
    </div>
    <v-dialog v-model="signDialog" :width="padW" F:height="padH">
      <v-signature-pad
        v-if="signDialog"
        :signatureLabel="signatureLabel"
        objectName="employee"
        :recordId="user_id"
        :portal="'portal_' + store.portalData.portal_id"
        filename="rep_signature.png"
        :upload="true"
        :w="padW"
        :h="padH"
      ></v-signature-pad>
    </v-dialog>
    <v-navigation-drawer v-model="aiDrawer" :clipped="true" right fixed app width="400">
      <v-btn v-if="$vuetify.breakpoint.mdAndDown" @click="aiDrawer = false" small icon
        ><v-icon>mdi-close</v-icon></v-btn
      >
      <AIChat v-bind="aiChatVBind" :key="aiChatKey" ref="aiChat"></AIChat>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
import Vue from "vue";
import VueSession from "vue-session";
import Vuetify from "vuetify/lib";

import io from "socket.io-client";
// const { MongoClient } = require('mongodb');
Vue.use(Vuetify);
Vue.use(VueSession);
window.keyPressed = false;

document.addEventListener("keydown", function() {
  window.keyPressed = true;
});
Vue.mixin({
  data: function() {
    return {
      get serverURL() {
        // console.log(fun.getServerURL());

        return fun.getServerURL();

        // if (window.location.host.indexOf("localhost") != -1) {
        //   return "https://127.0.0.1/5000";
        // }

        // return "https://portal.emoversoftware.com";
      },
      get hostName() {
        return window.location.protocol + "//" + window.location.host;
      },
      get passPhrase() {
        return "the software for moving that moving the moving industry";
      }
      // get getObjectStructure(){
      //   return this.getObjectStructure(file,feedback)
      // }
    };
  }
  // beforeCreate() {
  //   const methods = this.$options.methods;
  //   if (methods) {
  //     Object.keys(methods).forEach((methodName) => {
  //       const originalMethod = methods[methodName];
  //       methods[methodName] = function(...args) {
  //         if (window.keyPressed) {
  //           console.time();
  //           console.log(`Method ${methodName} called with`, args);
  //           window.keyPressed = false; // Reset the flag
  //           console.timeEnd();
  //         }
  //         return originalMethod.apply(this, args);
  //       };
  //     });
  //   }
  // },
});

import Confirm from "@/components/Confirm";
import VPopUp from "@/components/Popup";
import Search from "@/components/Search";
import SideMenu from "@/components/Menu";

import Login from "./views/auth/Login";
import Shipment from "./views/Shipment";
import Storage from "./views/Storage";
// import NewShipment from "./views/NewShipment";
import Employee from "./views/Employee";
import Customers from "./views/Customers";
import CustomerDetail from "./views/CustomerDetail";
import Report from "./views/Report";

import * as fun from "./plugins/common";

import axios from "axios";

import store from "./store";
import InternationalShipments from "./views/InternationalShipments.vue";

export default {
  // theme: { dark: true },

  components: {
    Login,
    Confirm,
    SideMenu,
    VPopUp,
    Search,
    VSignaturePad: () => import("@/components/SignaturePad.vue"),
    CreditCard: () => import("./components/CreditCard.vue"),
    Chat: () => import("./components/Chat.vue"),
    AIChat: () => import("./components/AIChat.vue"),
    StripeForm: () => import("./components/StripeForm.vue"),
    DemoGuide: () => import("./components/DemoGuide.vue")
  },

  props: {
    source: String
  },
  data: () => ({
    demoToast: {
      show: false,
      text: ""
    },
    darkMode: false,
    deferredPrompt: null,
    showInstallPrompt: false,
    version: "",
    padW: 500,
    padH: 300,
    signDialog: false,
    employee_id: "",
    signatureLabel: "Please create your signature",
    permissionsReady: false,
    socket: null,
    socketServer: null,
    me: "",
    dialog: false,
    drawer: null,
    resentTabs: [],
    router: null,
    addedClasses: "",
    activeTab: 0,
    menuKey: 0,
    aiChatKey: 0,
    lastTabIndex: -1,
    remove: false,
    updatedTabs: [],
    reset: false,
    tabKey: 0,
    shipmentUid: 0,
    successMessage: "",
    progressMessage: "",
    progressMessageError: "",
    errorMessage: "",
    pathToLetterFields: "translate/letter_fields.json",
    isCreateAccount: false,
    aiDrawer: false,
    allowedRoutes: [],
    removedRoutes: [],
    menuItems: [],
    snackBarHeight: 70,
    messages: [],
    timeout: -1,
    show: true,
    items: [],
    store: {},
    subdomain: "",
    charge: false,
    hideSearch: false,
    cannotCreateJob: false,
    noChat: false,
    idleTime: 3,
    mongoUrl: "mongodb://localhost:27017",
    isHost: false,
    defaultRoutes: [
      "/login",
      "create-account",
      "moverai-packages",
      "charge-card",
      "customer-inventory",
      "form-wrapper"
    ],
    euFormat: false,
    logo: "",
    canEditForm: false,
    aiChatVBind: null,
    preferences: [],
    hideAppBar: false,
    no_internet: false,
    offlineTimer: null
  }),
  created() {
    var that = this;
    window.addEventListener("beforeinstallprompt", this.beforeInstallPrompt);
    // this.checkSlideGesture();

    var socketServerUrl = fun.getServerURL();

    this.socketServer = io(socketServerUrl, {
      secure: socketServerUrl.startsWith("https")
    });

    this.socketServer.on("connect", () => {
      console.log("Connected to server");
    });

    this.socketServer.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    this.socketServer.connect(); // Manually connect
    // this.socketServer.on("lead_received", d => {
    //   console.log(d);
    //   if (this.customer_id) {
    //     return;
    //   }

    //   var qry = this.$root.getQry();
    //   qry["$and"].push({
    //     shipment_id: d.data.shipment_id
    //   });

    //   // if (!qry["$or"].length) {
    //   //   delete qry["$or"];
    //   // }

    //   axios
    //     .post(
    //       this.serverURL + "/get_data",
    //       {
    //         qry: qry,
    //         object_name: "shipments"
    //       },
    //       {
    //         withCredentials: true
    //       }
    //     )
    //     .then(response => {
    //       var rec = response.data;
    //       if (rec.model && rec.model.length) {
    //         var data = rec.model[0];
    //         var title = "New Lead!";
    //         var message = "New Lead # " + data.shipment_id + " " + data.first_name + " " + data.last_name;
    //         that.messages.push({
    //           text: message,
    //           color: "info",
    //           title: title,
    //           link: {
    //             shipment_id: data.shipment_id,
    //             first_name: data.first_name,

    //             last_name: data.last_name
    //           }
    //         });
    //         if (
    //           that.$root.store.userData.roles.includes("Sales Person") ||
    //           that.$root.store.userData.roles.includes("sales_person")
    //         ) {
    //           this.sendNotification(message, title);
    //         }
    //       }
    //     });
    // });

    this.socketServer.on("lead_received", d => {
      this.handleLeadLikeEvent(d, {
        title: "New Lead!",
        messageBuilder: data => `New Lead #${data.shipment_id} ${data.first_name} ${data.last_name}`
      });
    });
    this.socketServer.on("ai_quote", d => {
      this.handleLeadLikeEvent(d, {
        title: "AI Quote Ready",
        messageBuilder: data => `AI quote ready for #${data.shipment_id} ${data.first_name} ${data.last_name}`
      });
    });
    this.socketServer.on("ai_booking_confirmation", d => {
      this.handleLeadLikeEvent(d, {
        title: "Booking Confirmed 🤝",
        messageBuilder: data => `Booking confirmed for #${data.shipment_id} ${data.first_name} ${data.last_name}`
      });
    });

    this.socketServer.on("sms_received", data => {
      var decoded = new TextDecoder().decode(data);
      data = fun.queryStringToJSON(decoded);
      if (data.reply == "True" && (data.user == that.email || !data.user)) {
        var message = data.description.replaceAll("+", " ");
        var title = "Reply from " + data.first_name + " " + data.last_name;
        that.messages.push({
          text: message,
          color: "info",
          title: title,
          link: {
            shipment_id: data.shipment_id,
            first_name: data.first_name,
            last_name: data.last_name
          }
        });
        // const notificationSound = new Audio("notify.wav");
        // notificationSound.play();

        this.sendNotification(message, title);
      }
    });
  },
  mounted() {
    window.addEventListener("offline", () => {
      this.no_internet = true;
      this.startOfflineTimer();
    });
    window.showDemoToast = text => {
      this.demoToast.text = text;
      this.demoToast.show = false;

      // force re-trigger
      this.$nextTick(() => {
        this.demoToast.show = true;
      });
    };
    if (!window.__DEMO__) {
      const saved = localStorage.getItem("DEMO_STATE");

      window.__DEMO__ = saved
        ? JSON.parse(saved)
        : {
            active: false,
            scenario: null,
            step: 0
          };
    }

    window.addEventListener("online", () => {
      this.restoreQueue();
    });
    if (this.$route.fullPath.toLowerCase().indexOf("customerdocument") != -1) {
      return;
    }
    if (this.$route.fullPath.toLowerCase().indexOf("customer-inventory") != -1) {
      return;
    }
    if (this.$route.fullPath.toLowerCase().indexOf("charge-card") != -1) {
      return;
    }
    if (this.$route.fullPath.toLowerCase().indexOf("lead-access") != -1) {
      return;
    }
    // if (this.$route.fullPath.toLowerCase().indexOf("aichat") != -1) {
    //   return;
    // }
    if (this.$route.fullPath.toLowerCase().indexOf("create-account") != -1) {
      return;
    }

    if (this.$route.fullPath.toLowerCase().indexOf("moverai-packages") != -1) {
      return;
    }
    if (this.$route.fullPath.toLowerCase().indexOf("login") != -1) {
      return;
    }
    if (this.$route.fullPath.toLowerCase().indexOf("/q/") != -1) {
      return;
    }

    if (this.$route.fullPath.toLowerCase().indexOf("aichat") == -1) {
      this.checkSession();
    }

    // this.logout();
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    try {
      this.$root.position = JSON.parse(localStorage["portalData"]).address.address.geo.location.position;
    } catch (error) {
      //
    }

    // If there are more than two parts, the first part is the subdomain
    try {
      this.euFormat = JSON.parse(localStorage["portal_settings"])[0]["european_date_format"];
    } catch (error) {
      //
    }

    var dev = fun.isDev();
    if (dev && parts.length > 1) {
      this.subdomain = parts[0];
      this.charge = true;
    } else {
      if (parts[0] == "charge") {
        this.charge = true;
      }
    }
    if (this.charge) {
      return;
    }
    const packageJson = require("../package.json");
    this.version = packageJson.version;
    try {
      Object.keys(localStorage).forEach(k => {
        try {
          this.store[k] = JSON.parse(localStorage[k]);
        } catch (error) {
          //
        }
      });
    } catch (error) {
      //
    }
    // if (this.$root.customerId) {
    //   axios
    //     .post(
    //       this.serverURL + "/get_data",
    //       {
    //         all_records: true,

    //         object_name: "company",
    //       },
    //       {
    //         withCredentials: true,
    //       }
    //     )
    //     .then((response) => {
    //       console.log(response);
    //     });
    // }

    this.$session.start();
    // this.isAuthenticated = this.$store.state.auth.isAuthenticated;
    // this.$session.set("portal_id", "5f574b8d1f37d03080dd614c");
    this.populateMenu();
    this.$hideAppBar = this.hideAppBar;
    this.$root.logo = this.logo;
    this.$root.ajustColor = this.ajustColor;
    this.$root.drawer = this.drawer;
    this.$root.store = this.store;
    this.idleTime = parseInt(this.store.idle_time || 3);
    this.$root.portal_settings = this.store.portal_settings;
    this.$root.$confirm = this.$refs.confirm;
    this.$root.alertDialog = this.alertDialog;
    this.$root.addResentTab = this.addResentTab;
    window.addResentTab = this.addResentTab;
    this.$root.reloadCurrentTab = this.reloadCurrentTab;
    this.$root.removeResentTab = this.removeResentTab;
    this.$root.resentTabs = this.resentTabs;
    // this.$root.activeTab = this.activeTab;
    this.$root.updatedTabs = this.updatedTabs;
    this.$root.dynamicClasses = this.dynamicClasses;
    this.$root.logout = this.logout;
    this.$root.checkUpdate = this.checkUpdate;
    this.$root.tabKey = this.tabKey;
    this.$root.shipmentUid = this.shipmentUid;
    this.$root.reset = this.reset;
    this.$root.sendMail = this.sendMail;
    this.$root.sendSMS = this.sendSMS;
    this.$root.darkMode = this.darkMode;
    this.$root.aiDrawer = this.aiDrawer;
    this.$root.no_internet = this.no_internet;

    // this.$root.createExcel = this.createExcel;
    // this.$root.encrypt = this.encrypt;
    // this.$root.decrypt = this.decrypt;
    this.$root.getObjectStructure = this.getObjectStructure;
    this.$root.isCreateAccount = this.isCreateAccount;
    // this.$root.$on("loginSuccessful", (d) => {
    //   this.isAuthenticated = true;
    // });
    this.$root.user_id = this.user_id;
    this.$root.user_email = this.email;
    this.$root.savePreferences = this.savePreferences;
    this.$root.preferences = this.preferences;

    if (this.store.portalData) {
      this.$root.portal_id = this.store.portalData.portal_id;
    }
    this.$root.createPdf = this.createPdf;
    this.$root.customerId = this.customerId;
    this.$root.roles = this.roles;
    this.$root.isAdmin = this.isAdmin;
    this.$root.filterShipments = this.filterShipments;
    this.$root.filteredCompanies = this.filteredCompanies;
    this.$root.isMobile = this.isMobile;
    this.$root.isTablet = this.isTablet;
    this.$root.getQry = this.getQry;
    this.$root.euFormat = this.euFormat;
    this.$root.progressMessage = this.progressMessage;
    this.$root.canEditForm = this.canEditForm;
    this.$root.findZone = this.findZone;
    try {
      this.$store.dispatch("auth/CHECK_SESSION").catch(reason => {
        // console.log("Here:", reason.response.data);
        this.logout();
      });
    } catch (error) {
      //
    }
    try {
      if (
        !this.$store.state.auth.isAuthenticated &&
        !this.$route.fullPath.toLowerCase().indexOf("aichat") == -1 &&
        !this.$route.fullPath.toLowerCase().indexOf("customerdocument") == -1 &&
        !this.$route.fullPath.toLowerCase().indexOf("charge-card") == -1 &&
        !this.$route.fullPath.toLowerCase().indexOf("customer-inventory") == -1 &&
        !this.$route.fullPath.toLowerCase().indexOf("component-on-demand") == -1 &&
        !this.$route.fullPath.toLowerCase().indexOf("lead-access") == -1 &&
        !this.$route.fullPath.toLowerCase().indexOf("/q/") == -1
      ) {
        this.logout();
      }
    } catch (error) {
      //
    }

    this.getObjectStructure();
    // this.resentTabs
    // if (this.$router.currentRoute.path !== "/") {
    //   this.$router.push("/");
    // }

    var socketUrl = fun.getSocketURL();
    socketUrl = "https://server.moverai.com:5000";
    var that = this;

    this.socket = io(socketUrl);

    this.socket.on("me", id => {
      this.me = id;
    });

    //chunk_received

    // this.socket.on("chunk_received", (d) => {
    //   console.log(d);
    //   that.$root.$emit("chunk_received", d.text);
    //   that.$emit("chunk_received", d.text);
    // });

    this.socket.on("chunk_received", async msg => {
      // console.log(msg);
      if (msg.action === "open_and_fill_form") {
        const { route, form_values } = msg.action_data || {};

        if (route) {
          this.$router.push({ name: route });
          await this.waitForFormRender();
        }

        this.simulateFormTyping(form_values);
      }
    });

    this.socket.on("lead_received", d => {
      // console.log(d);
      if (d.action === "open_file" && d.file_url) {
        window.open(d.file_url, "_blank", "noopener");
        return;
      }
      var title = d.action ? fun.capitalize(d.action) : "New Lead";
      if (d.revision) {
        title = "Revison";
      }
      var message = (message = title + " # " + d.shipment_id);
      if (d.text) {
        message += " " + d.text;
      }

      if (that.store.portalData.portal_id.toString() == d.portal.toString()) {
        var color = "info";
        if (d.action) {
          color = "success";
          if (
            message
              ?.toString()
              .toLowerCase()
              .includes("stop")
          ) {
            color = "error";
          }
        }
        that.messages.push({
          text: message,
          color: color,
          title: title,
          link: {
            shipment_id: d.shipment_id
          }
        });
        if (
          that.$root.store.userData.roles.includes("Sales Person") ||
          that.$root.store.userData.roles.includes("sales_person")
        ) {
          this.sendNotification(message, title);
        }
        if (d.action) {
          var data = {
            metadata: {
              object_name: "notification",
              portal_id: d.portal.toString()
            },
            model: {
              message: message,
              color: color,
              time_stamp: fun.formatDate(new Date(), false, true),
              shipment_id: d.shipment_id
            }
          };
          axios
            .post(this.serverURL + "/add_notification", data, {
              withCredentials: true
            })
            .then(function(response) {
              console.log(response.data);
            });
        }
        return;
      }
      var qry = this.$root.getQry();
      qry["$and"].push({
        shipment_id: d.shipment_id
      });

      if (that.permittedActions) {
        that.permittedActions.forEach(a => {
          if (a.shipment_filter) {
            a.shipment_filter.forEach(f => {
              Object.keys(f).forEach(k => {
                if (Array.isArray(f[k]) && f[k].length) {
                  let q = {};
                  q[k] = { $in: f[k] };
                  that.qry.$and.push(q);
                }
              });
            });
          }
        });
      }

      var employee_id = 0;
      try {
        employee_id = that.$root.store.userData._id.$oid;
      } catch (error) {
        //
      }
      axios
        .post(
          that.serverURL + "/get_data",
          {
            qry: qry,
            object_name: "shipments",
            schema_name: "v_shipments",
            additional_data: [
              {
                obj_name: "employee",

                qry: { _id: employee_id }
              }
            ]
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          var rec = response.data;
          var salesPerson = rec.additional_model.employee;
          var autoAssign = false;
          if (salesPerson.length) {
            salesPerson = salesPerson[0];
            autoAssign = salesPerson.auto_assign_leads;
          }
          if (rec.model && rec.model.length) {
            var data = rec.model[0];

            message = title + " # " + data.shipment_id + " " + data.first_name + " " + data.last_name;
            var messageAllowed = false;

            if ((data.shipment_detail && !data.shipment_detail.sales_person) || d.action) {
              if (!autoAssign) {
                messageAllowed = true;
              }
            }
            try {
              if (
                data.shipment_detail &&
                data.shipment_detail.sales_person &&
                data.shipment_detail.sales_person._id == that.$root.store.userData._id.$oid
              ) {
                messageAllowed = true;
              }
            } catch {
              if (!autoAssign) {
                messageAllowed = true;
              }
            }
            if (messageAllowed) {
              that.messages.push({
                text: message,
                color: d.action ? "success" : "info",
                title: title,
                link: {
                  shipment_id: data.shipment_id,
                  first_name: data.first_name,

                  last_name: data.last_name
                }
              });
              if (
                that.$root.store.userData.roles.includes("Sales Person") ||
                that.$root.store.userData.roles.includes("sales_person")
              ) {
                this.sendNotification(message, title);
              }
            }
          }
        });
    });
    this.socket.on("sms_received", data => {
      // var decoded = new TextDecoder().decode(data);
      // data = fun.queryStringToJSON(decoded);
      if (data.reply == true && (data.user == that.email || !data.user)) {
        var message = data.description.replaceAll("+", " ");
        var title = "Reply from " + data.first_name + " " + data.last_name;
        that.messages.push({
          text: message,
          color: "info",
          title: title,
          link: {
            shipment_id: data.shipment_id,
            first_name: data.first_name,
            last_name: data.last_name
          }
        });
        // const notificationSound = new Audio("notify.wav");
        // notificationSound.play();

        this.sendNotification(message, title);
      }
    });
    this.$root.$on("darkModeUpdated", d => {
      that.darkMode = d;
    });
    this.socket.on("connect", function(d) {
      console.log(that.socket.id);
      that.socket.emit("register", {
        user: that.$root.user_id
      });
    });

    this.socket.on("progress", data => {
      if (that.socket.id == that.me) {
        if (that.store.portalData == "admin") {
          that.progressMessage = data.text;
          that.progressMessageError = data.error;
          this.$root.$emit("progress-update", data.text);
        }
      }
      // console.log("progress received:", data);

      // Handle the notification (e.g., display a message to the user)
    });
    this.$root.socket = this.socket;
    if (!this.resentTabs.length && !this.customerId) {
      var dashboard = {
        icon: "mdi-view-dashboard",
        text: "Dashboard",
        link: "/dashboard",
        order: 1,
        key: "9dcf8c4b8d3671edac5a079d",
        permitted: true
      };
      this.addResentTab(dashboard);
    }
    this.timeLogin();
  },

  methods: {
    startOfflineTimer() {
      if (this.offlineTimer) return;

      this.offlineTimer = setInterval(() => {
        if (navigator.onLine) {
          this.restoreQueue();
        }
      }, 5000);
    },
    async restoreQueue() {
      if (!navigator.onLine) return;

      let queue = JSON.parse(localStorage.getItem("offline_queue") || "[]");

      if (!queue.length) return;

      for (const data of queue) {
        try {
          await this.axios.post(this.serverURL + "/add_data", data, {
            withCredentials: true
          });
        } catch (e) {
          return;
        }
      }

      localStorage.removeItem("offline_queue");

      this.no_internet = false;

      clearInterval(this.offlineTimer);
      this.offlineTimer = null;
    },
    handleShipmentEvent(d, options = {}) {
      const {
        title = "Update",
        messageBuilder = data => `Update for #${data.shipment_id} ${data.first_name} ${data.last_name}`
      } = options;

      // -------------------------------
      // Build query
      // -------------------------------
      const qry = this.$root.getQry();

      if (!qry["$and"]) qry["$and"] = [];
      qry["$and"].push({ shipment_id: d.shipment_id });

      if (this.permittedActions) {
        this.permittedActions.forEach(a => {
          if (a.shipment_filter) {
            a.shipment_filter.forEach(f => {
              Object.keys(f).forEach(k => {
                if (Array.isArray(f[k]) && f[k].length) {
                  let q = {};
                  q[k] = { $in: f[k] };
                  qry["$and"].push(q);
                }
              });
            });
          }
        });
      }

      // -------------------------------
      // Employee lookup
      // -------------------------------
      let employee_id = 0;
      try {
        employee_id = this.$root.store.userData._id.$oid;
      } catch {
        //
      }

      axios
        .post(
          this.serverURL + "/get_data",
          {
            qry,
            object_name: "shipments",
            schema_name: "v_shipments",
            additional_data: [
              {
                obj_name: "employee",
                qry: { _id: employee_id }
              }
            ]
          },
          { withCredentials: true }
        )
        .then(response => {
          const rec = response.data;

          // -------------------------------
          // Auto-assign logic
          // -------------------------------
          let autoAssign = false;
          const salesPerson = rec.additional_model?.employee;
          if (salesPerson && salesPerson.length) {
            autoAssign = salesPerson[0].auto_assign_leads;
          }

          if (!rec.model || !rec.model.length) return;

          const data = rec.model[0];
          const message = messageBuilder(data);
          let messageAllowed = false;

          // -------------------------------
          // Visibility rules (UNCHANGED)
          // -------------------------------
          if (data.shipment_detail && !data.shipment_detail.sales_person) {
            if (!autoAssign) messageAllowed = true;
          }

          try {
            if (data.shipment_detail?.sales_person?._id == this.$root.store.userData._id.$oid) {
              messageAllowed = true;
            }
          } catch {
            if (!autoAssign) messageAllowed = true;
          }

          if (!messageAllowed) return;

          // -------------------------------
          // UI + notification
          // -------------------------------
          this.messages.push({
            text: message,
            color: "info",
            title,
            link: {
              shipment_id: data.shipment_id,
              first_name: data.first_name,
              last_name: data.last_name
            }
          });

          if (
            this.$root.store.userData.roles.includes("Sales Person") ||
            this.$root.store.userData.roles.includes("sales_person")
          ) {
            this.sendNotification(message, title);
          }
        });
    },
    waitForFormRender() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          setTimeout(resolve, 500); // give extra time for inputs to appear
        });
      });
    },

    async simulateFormTyping(formValues) {
      for (const field in formValues) {
        const value = formValues[field];
        let simulatedValue = "";

        for (let i = 0; i < value.length; i++) {
          simulatedValue += value[i];

          // Use custom event for field injection
          this.$emit("simulate-typing", { field, value: simulatedValue });

          await this.sleep(50 + Math.random() * 100); // simulate key delay
        }
      }
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    getPreferences(p, objectName) {
      var that = this;

      var data = {
        metadata: {
          object_name: "preferences"
        },

        model: {
          _id: p.name,
          value: p.value,
          object_name: objectName,
          user_id: this.$root.user_id
        }
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
        });
    },

    savePreferences(p, objectName) {
      var that = this;
      var data = {
        metadata: {
          object_name: "preferences"
        },

        model: {
          _id: p._id || fun.guid(),
          value: p.value,
          object_name: objectName,
          property: p.name,
          user_id: this.$root.user_id
        }
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          that.preferences = that.preferences.filter(pref => pref._id !== data.model._id);

          // add new / updated one
          that.preferences.push(data.model);
          that.$root.preferences = that.preferences;
          console.log(that.preferences);
        });
    },
    addDefaultTab(d) {
      var defaultTab = {
        // icon: "mdi-view-dashboard",
        text: d.text,
        link: d.link,
        order: 1,
        key: d._id,
        permitted: true
      };
      this.addResentTab(defaultTab);
    },
    createPdf(data, feedback) {
      // var html = document.getElementById("myReport").innerHTML;

      data.host = `${location.protocol}//${location.hostname}:${location.port}`;

      // this.loading = true;
      try {
        axios
          .post(this.serverURL + "/create_pdf", data)
          .then(response => {
            console.log(response.data);

            const url = response.data;
            window.open(url, "_blank");
            if (feedback) {
              feedback(true);
            }
            // }
          })
          .catch(function(error) {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    filteredCompanies() {
      // if(this.$root.store.userData.roles.toLowerCase().includes("admin"))
      if (this.$root.store.userData.roles) {
        const isAdmin = this.$root.store.userData.roles.some(item => item.toLowerCase() === "admin");
        if (isAdmin) {
          return;
        }

        var filterCompany = false;

        var permittedActions = this.$root.store.permittedActions;

        if (permittedActions) {
          permittedActions.forEach(a => {
            if (a.only_assigned_company) {
              filterCompany = true;
            }
          });
        }
        if (filterCompany) {
          var list_of_company_ids = this.$root.store.userData.company.map(c => (c._id ? c._id["$oid"] || c._id : c));
          return list_of_company_ids;
        }
      }
    },
    filterShipments() {
      var doFilter = false;
      this.currentUser = this.$root.store.userData.email;

      var permittedActions = this.$root.store.permittedActions;

      if (permittedActions) {
        permittedActions.forEach(a => {
          if (a.filter_jobs && !this.isAdmin) {
            doFilter = true;
            // this.hideSearch = true;
          }
        });
      }
      return doFilter;
    },
    getQry(search) {
      var qry = { $and: [] };

      this.currentUser = this.$root.store.userData.email;
      var permittedActions = this.$root.store.permittedActions;
      var filterJobs = false;
      var noBooked = false;
      // var filterCompany = false;
      if (permittedActions) {
        permittedActions.forEach(a => {
          if (a.filter_jobs && !this.$root.isAdmin) {
            filterJobs = true;
            // .sales_person_email = this.currentUser;
          }
          if (a.bulk_delete) {
            this.noDelete = false;
          }
          if (a.hide_booked_jobs && !this.$root.isAdmin) {
            noBooked = true;
          }
          // if (a.only_assigned_company) {
          //   filterCompany = true;
          // }
        });
      }
      var noBookedQry = {
        $or: [
          { booked: 0 },
          {
            booked: { $exists: false }
          }
        ]
      };

      if (filterJobs && !search) {
        // var booked = fun.clone(this.data_object.qry.booked);
        qry = {
          $and: [
            {
              $or: [
                { "shipment_detail.sales_person._id": this.$root.user_id },
                { "agent.contact.email": this.currentUser }
              ]
            }
          ]
        };
        if (noBooked) {
          qry.$and.push(noBookedQry);
        }
      } else {
        if (noBooked) {
          qry = {
            $and: [noBookedQry]
          };
          // } else {
          //   this.data_object.qry = this.dateQry;
        }
      }
      if (!this.isHost) {
        if (this.filteredCompanies()) {
          var filterCompanyQry = {
            $expr: {
              $in: [{ $toString: "$shipment_detail.company._id" }, this.$root.filteredCompanies()]
            }
            // "shipment_detail.company._id": {
            //   $in: this.$root.filteredCompanies(),
            // },
          };
          // if (!this.data_object.qry.$and) {
          // qry.$and = [];
          // }
          qry.$and.push(filterCompanyQry);
        }
      }
      return qry;
    },
    sendNotification(msg, title) {
      if ("Notification" in window) {
        // Request permission to show notifications
        Notification.requestPermission().then(function(permission) {
          if (permission === "granted") {
            // Create and show the notification
            var notification = new Notification(title, {
              body: msg,
              icon: "favicon.png" // Optional: You can specify an icon for the notification
            });

            // Handle notification click event (optional)
            notification.onclick = function() {
              // Do something when the user clicks on the notification
              console.log("Notification clicked.");
            };
          } else {
            console.log("Notification permission denied.");
          }
        });
      } else {
        console.log("Notifications not supported by this browser.");
      }
    },
    getRole(roleName, feedback) {
      var that = this;
      var d = {
        object_name: "roles",
        qry: {
          name: roleName
        },
        additional_data: [
          {
            obj_name: "preferences",
            qry: { user_id: this.user_id }
          }
        ]
      };
      axios
        .post(this.serverURL + "/get_data", d, {
          withCredentials: true
        })
        .then(response => {
          // console.log(response);
          that.preferences = response.data.additional_model.preferences;
          that.$root.preferences = that.preferences;

          feedback(response.data.model);
        });
    },
    testPopup() {
      var that = this;
      var data = {};
      try {
        var decoded = new TextDecoder().decode(data);
        data = fun.queryStringToJSON(decoded);
      } catch (error) {
        //
      }

      var message = data.description.replaceAll("+", " ");
      that.messages.push({
        text: message,
        color: "info",
        title: "Reply from " + data.first_name + " " + data.last_name,
        link: {
          shipment_id: data.shipment_id,
          first_name: data.first_name,
          last_name: data.last_name
        }
      });
    },
    checkSession() {
      axios
        .post(
          this.serverURL + "/check_session",
          {},
          {
            withCredentials: true
          }
        )
        .then(response => {
          // console.log(response.data);
          if (response.data == "No portal") {
            this.logout();
          }
        });
    },
    timeLogin() {
      var that = this;
      setInterval(function() {
        try {
          if (localStorage.getItem("loginTime")) {
            var lastActiveTime = new Date(localStorage.getItem("loginTime"));
            var curIdleTime = lastActiveTime.getHours() - new Date().getHours();
            if (curIdleTime > that.idleTime) {
              that.logout();
            } else {
              // console.log("idle time", curIdleTime);
            }
          }
        } catch (error) {
          //
        }
      }, 600000);
    },
    findZone(addr, zone, company) {
      var that = this;
      var loc = {};
      var geo = fun.deepFind(addr, "geo");
      if (!geo && addr && addr.address) {
        geo = addr.address.geo;
      }
      if (!geo) {
        return "";
      }
      var location = geo.location.address || geo.location;
      var elementInArray = function(array, el) {
        if (!el) return false;
        if (!Array.isArray(array)) {
          array = array.split(",");
        }
        const index = array.findIndex(element => {
          return !element || element.toString().toLowerCase() === el.toString().toLowerCase();
        });
        return index != -1;
      };
      var tariffZones = zone.filter(z => {
        return z.type == "tariff_zone";
      });

      var filteredZones = tariffZones.filter(z => !z.company || z.company.some(c => c._id === company._id));

      var myZones = filteredZones.filter(z => {
        if (z.states) {
          return elementInArray(z.states, location.stateCode);
        }
        if (z.locations) {
          return elementInArray(z.locations, location.stateCode);
        }
      });
      if (myZones.length) {
        myZones = myZones.filter(z => {
          return !z.counties || !z.counties.length || elementInArray(z.counties, location.county);
        });
      }
      if (myZones.length) {
        myZones = myZones.filter(z => {
          return !z.cities || !z.cities.length || elementInArray(z.cities, location.city);
        });
      }
      // console.log(myZones);
      if (myZones.length) {
        myZones.forEach(z => {
          if (z.type == "tariff_zone") {
            loc.zone = {
              zone_name: z.zone_name,
              zone_id: z._id
            };
          }
          if (z.type == "carrier_zone") {
            loc.carrier_zone = {
              zone_name: z.zone_name,
              zone_id: z._id
            };
          }
        });
        return loc;
        // if (addr.zone) {
        //   return addr.zone.zone_id;
        // }
      }
    },
    ajustColor(backColor) {
      if (typeof backColor == "object") {
        backColor = "fff";
      }
      if (backColor == "fff") {
        return "#000000";
      }
      return fun.calculateLuminance(backColor || "#000000");
    },
    isPWAInstalled() {
      return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    },
    beforeInstallPrompt(e) {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
      // Update UI to notify the user they can install the PWA
      // this.showInstallPrompt = !this.$vuetify.breakpoint.mdAndUp;
      //  && !this.isPWAInstalled();
    },
    async installPWA() {
      // Hide the app provided install prompt
      this.showInstallPrompt = false;
      // Show the install prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      const choiceResult = await this.deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the A2HS prompt");
        alert("Please close the browser window and open the app from the app icon installed");
        // window.close();
      } else {
        console.log("User dismissed the A2HS prompt");
      }
      // We've used the prompt, and can't use it again, throw it away
      this.deferredPrompt = null;
    },
    getSettings() {
      var allSettings = [
        "list_items",
        "material_list",
        // "haul_type",
        "trip_status",
        "lead_status",
        "order_status",
        "service_type",
        "service_category",
        "labor_type",
        "charge_category",
        "resource_type",
        // "unit_type",
        // "employee",

        // "agent",
        // "broker",
        "vehicle_type",
        "dashboard_settings",
        "employee_role",
        "agent_role",
        "delivery_status",
        // "other_role",
        "truck",
        "room",
        "source",
        "company",
        // "crm_action",
        "stage",
        "itinerary_step",
        "itinerary_status",
        "dwelling_type",
        "warehouse",
        "zone",
        // "zone_rate",
        "tariffs",
        "payment_type",
        "building",
        "document_type",
        "time_slot",
        // "chat_settings",
        "task",
        "progress_status",
        "employee_rate_name",
        "labor_rate_type",
        "ai_settings"
        // "report_wizard",
      ];
      var getSettingChildren = function(s) {
        switch (s) {
          case "employee":
            return [
              {
                icon: "mdi-worker",
                text: "Field Employee"
              },
              {
                icon: "mdi-account",
                text: "Office Employee"
              }
            ];

          default:
            return "";
        }
      };
      var createSettings = function() {
        const extraSettings = [
          {
            icon: "mdi-table-edit",
            text: "Letter Designer",
            link: "/document-designer/letter"
          },
          // {
          //   icon: "mdi-table-edit",
          //   text: "Document Designer",
          //   link: "/document-designer/document",
          // },
          {
            icon: "mdi-table-edit",
            text: "Report Designer",
            link: "/report-wizard"
          }
        ];
        var titles = {
          list_items: "List of Items"
        };
        allSettings = allSettings.map(setting => {
          return {
            icon: "mdi-cog",
            text: titles[setting] || fun.capitalize(setting),
            link: "/settings/" + setting,
            children: getSettingChildren(setting)
          };
        });
        allSettings = allSettings.concat(extraSettings);
        return allSettings.sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          } else if (a.text > b.text) {
            return 1;
          } else {
            return 0;
          }
        });
        // .map((setting) => {
        //   return {
        //     icon: "mdi-settings",
        //     text: titles[setting] || fun.capitalize(setting),
        //     link: "/settings/" + setting,
        //   };
        // });
      };

      return createSettings();
      // .concat(setting);
    },
    getMyParent(permissions, c) {
      var par;
      permissions.every(p => {
        if (p.children) {
          var strChildren = JSON.stringify(p.children);
          if (strChildren.includes(c)) {
            par = p;
            return false;
          }
        }
        return true;
      });
      return par;
    },
    getAdminViewsItems() {
      const allHostMenuItems = [
        {
          icon: "mdi-account-card-details",
          text: "Portal"
        },
        {
          icon: "mdi-account-card-details",
          text: "users"
        },
        {
          icon: "mdi-account-multiple",
          text: "roles"
        }
        // {
        //   icon: "mdi-account-key",
        //   text: "permissions",
        // },
      ];
      return allHostMenuItems.map(hostItem => {
        return {
          icon: hostItem.icon,
          text: fun.capitalizeFirstLetter(hostItem.text),
          link: "/admin/" + hostItem.text
        };
      });
    },
    getGuardViewsItems() {
      const allGuardMenuItems = [
        {
          icon: "desktop_access_disabled",
          text: "permissions"
        },
        {
          icon: "sticky_note_2",
          text: "default_roles"
        }
      ];
      return allGuardMenuItems.map(guardItem => {
        return {
          icon: guardItem.icon,
          text: fun.capitalizeFirstLetter(guardItem.text),
          link: "/guard/" + guardItem.text
        };
      });
    },

    populateMenu() {
      var data = {
        obj_name: "menu",
        folder: "structure",
        add_object_schema: true
      };
      axios
        .post(this.serverURL + "/get_schema", data, {
          withCredentials: true
        })
        .then(response => {
          var data = response.data;
          var all_items = new Map(data);
          // console.log(this.all_items);

          var newItems = [];
          var allItems = [];

          var that = this;
          var allowed = [];
          if (this.$store.getters["auth/permissions"]) {
            var permissions = this.$store.getters["auth/permissions"];
            var permittedActions = that.store.permittedActions;
            if (permittedActions) {
              permittedActions.forEach(a => {
                if (a.filter_jobs && !this.isAdmin) {
                  // that.hideSearch = true;
                }
                if (a.cannot_create_job && !this.isAdmin) {
                  that.cannotCreateJob = true;
                }
                if (a.no_chat && !this.isAdmin) {
                  that.noChat = true;
                }
              });
            }

            // permissions = permissions.filter((p) => {
            //   return !p.includes(":");
            // });
            var menuItems = permissions.filter(p => {
              return !p.includes(":");
            });
            if (that.store.portalData == "admin") {
              this.isHost = true;
              this.$root.isHost = this.isHost;
              all_items.forEach(a => {
                if (a.hostOnly) {
                  newItems.push(a);
                }
              });
              //hostOnly
            } else {
              all_items.forEach(a => {
                permissions.forEach(host_view => {
                  host_view = host_view
                    .split(".")[0]
                    .toLowerCase()
                    .replaceAll(" ", "_");
                  if (
                    a.text
                      .split(".")[0]
                      .toLowerCase()
                      .replaceAll(" ", "_") == host_view
                  ) {
                    a.permitted = true;
                  }
                  if (!newItems.includes(a)) {
                    if (!a.portals || a.portals.includes(this.store.portalData.portal_id)) {
                      a.key = fun.guid();
                      newItems.push(a);
                      // if (a.children) {
                    }
                  }
                  // if (!allItems.includes(a)) {
                  //   allItems.push(fun.clone(a));
                  // }
                });
                // if (that.all_items.has(host_view)) {

                // }
              });
            }

            // console.log("New Items:", newItems);

            newItems.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));

            newItems.forEach(i => {
              if (i.link) {
                that.allowedRoutes.push(i.link);
              }
              i.children = eval(i.children);
              if (i.children) {
                var pId = i.text
                  .split(".")[0]
                  .toLowerCase()
                  .replaceAll(" ", "_");
                var allowedChildren = [];
                i.children.forEach(c => {
                  if (!c.portals || c.portals.includes(that.store.portalData.portal_id.toString())) {
                    c.key = fun.guid();
                    c.ref = "child-" + c.key;
                    var cId = c.text
                      .split(".")[0]
                      .toLowerCase()
                      .replaceAll(" ", "_");
                    var fullId = pId + "." + cId;
                    if (permissions.includes(fullId)) {
                      c.permitted = true;
                      i.permitted = true;
                    }

                    if (c.link) {
                      that.allowedRoutes.push(c.link);
                      // allowedChildren.push(c);
                    }
                  }
                });
                // i.children = allowedChildren;
              }
              if (i.obj_name) {
                // console.log(i);
              }
            });

            that.$router.options.routes.forEach(r => {
              // console.log(r);
              if (
                !that.allowedRoutes.filter(a => {
                  return a == r.path;
                }).length &&
                !that.defaultRoutes.includes(r.path)
              ) {
                that.removedRoutes.push(r);
              }
            });

            if (
              that.removedRoutes.length &&
              !that.allowedRoutes.filter(r => {
                return r == that.$route.path;
              }).length
            ) {
              if (that.allowedRoutes.includes("/shipments") && that.$route.path.includes("shipment")) {
                this.items = newItems;
              } else {
                // that.$router.push({ path: that.allowedRoutes[0] });
              }
            }
            this.items = newItems;
            // return newItems;
          } else {
            this.items = [];
          }
          // commit("MENU_ITEMS", newItems);
          this.$root.menuItems = this.newItems;
          localStorage.setItem("menuItems", JSON.stringify(newItems));
          localStorage.setItem("permittedKeys", JSON.stringify(permissions));
          if (!that.store.portalData == "admin") {
            this.checkAllowedRoutes();
          }
          if (that.store.userData.roles) {
            that.store.userData.roles.forEach(r => {
              this.getRole(r, role => {
                if (role && role.length) {
                  if (role[0].default_screen && that.$router.currentRoute.path == "/dashboard") {
                    this.addDefaultTab(role[0].default_screen);
                    this.$router.push(role[0].default_screen.link);
                  }
                }
                // console.log(role);
              });
            });
          }

          this.permissionsReady = true;
        })
        .catch(reason => {
          // this.logout();
          console.log(reason);
        });
    },
    calcMargin(i) {
      return i * this.snackBarHeight + "px";
    },
    hide(i) {
      this.messages.splice(i, 1);
    },

    isCreateAccount(c) {
      this.isCreateAccount = c;
    },
    sendSMS(d) {
      if (typeof d.company_id === "object") {
        d.company_id = d.company_id._id;
      }
      var data = {
        message: d.description,
        phone_number: d.phone_number,
        company_id: d.company_id,
        client_id: d.client_id
      };

      axios
        .post(this.serverURL + "/send_sms", data, {
          withCredentials: true
        })
        .then(response => {
          this.$root.$emit("sms_sent", response);
        });
    },
    sendMail(mailData) {
      var that = this;
      that.successMessage = "";
      that.errorMessage = "";
      // var mailData = {
      //   message: that.letterBody,
      //   subject: that.eMailSubject,
      //   email_to: [that.email],
      // };
      axios
        .post(this.serverURL + "/send_email_emover", mailData, {
          withCredentials: true
        })
        .then(response => {
          console.log(response);
          if (response.data.sent.includes("success")) {
            that.successMessage = response.data.sent;
          } else {
            that.errorMessage = "Error occured: " + response.data.sent;
          }
        });
    },

    getObjectStructure() {
      axios
        .post(this.serverURL + "/get_file", {
          f: this.pathToLetterFields
        })
        .then(response => {
          var r = JSON.stringify(response.data);
          localStorage.setItem("letterFields", r);
        })
        .catch(reason => {
          this.logout();
        });
    },
    checkUpdate(v) {
      if (this.updatedTabs.includes(v.$route.path)) {
        this.updatedTabs.splice(this.updatedTabs.indexOf(v.$route.path), 1);
        return true;
      }
    },
    alertDialog(dialogTitle, dialogText) {
      var popup = this.$refs.popup;
      popup.dialogTitle = dialogTitle;
      popup.dialogText = dialogText;
      popup.dialog = true;
    },
    refreshTab(t, reload) {
      this.$router.push({ path: t.link }).catch(err => {
        // ignore the vuex err regarding duplicate route entries
        if (err.name !== "NavigationDuplicated") {
          // handle other errors
        }
      });
      if (reload) {
        this.$router.go(t.link);
      }
    },
    dynamicClasses(classes) {
      let style = document.createElement("style");
      style.type = "text/css";
      if (document.head.innerHTML.indexOf(classes == -1)) {
        document.head.appendChild(style);
        style.innerHTML = classes;
      }

      // this.addedClasses = style;
    },
    addToOpenShipments(shipmentId, remove) {
      var data = {
        metadata: {
          object_name: "open_shipment",
          qry: {
            shipment_id: shipmentId
          }
        }
      };

      if (!remove) {
        data.model = {
          shipment_id: shipmentId,
          date_time: new Date(),
          action: "open",
          user: this.currentUser
        };
      } else {
        data.model = {
          shipment_id: shipmentId,
          action: "closed",
          date_time: new Date(),
          user: this.currentUser
        };
      }
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
        });
    },
    addResentTab(item) {
      var data = this.resentTabs;

      var tab = {};
      if (item.shipment_id || item.shipment_id == 0) {
        tab.shipment_id = item.shipment_id;
        if (parseInt(tab.shipment_id) == 0) {
          tab.text = "New Shipment";
          tab.link = "/shipment/0";

          // data=data.filter(t=>{
          //   return t.link!="/shipment/0"
          // })
          if (!this.resentTabs.some(resentTab => resentTab.link === tab.link)) {
            this.resentTabs.push(tab);
          }
          this.activeTab = tab.link;
        } else {
          var shipmentExist = false;
          data.forEach((t, i) => {
            if (t.link == "/shipment/" + item.shipment_id) {
              shipmentExist = true;
            }
          });

          if (!shipmentExist) {
            var names = "";
            // if (item.first_name && item.last_name) {
            //   names = " " + item.first_name + " " + item.last_name;
            // }
            if (item.customer_name) {
              names = " " + item.customer_name;
            }
            if (item.name) {
              tab.text = "# " + item.name + names;
            } else {
              tab.text = "#" + item.shipment_id.toString().split("_")[0] + names;
            }

            tab.link = "/shipment/" + item.shipment_id;
            tab.icon = item.icon;
            this.activeTab = tab.link;
            this.$root.newShipmentTab = tab;
            this.resentTabs.push(tab);
            this.addToOpenShipments(item.shipment_id);
          }
        }

        this.$router.addRoutes([
          {
            path: "/shipment/" + item.shipment_id,
            component: Shipment,
            name: "shipment_" + item.shipment_id,
            props: true
          }
        ]);
        this.$router
          .push({
            path: tab.link,
            params: { id: item.shipment_id },
            name: "shipment_" + item.shipment_id
            // props: true,
          })
          .catch(err => {
            // ignore the vuex err regarding duplicate route entries
            if (err.name !== "NavigationDuplicated") {
              // handle other errors
            }
          });
      } else if (item.storage_id) {
        tab.storage_id = item.storage_id;
        tab.text = "Storage";
        var id = "";
        if (parseInt(tab.storage_id) == 0) {
          tab.link = "/storage/" + tab.storage_id;
          if (item.sid) {
            id = item.storage_id = "0:" + item.sid;
            tab.link = "/storage/" + id;
          }

          if (!this.resentTabs.some(resentTab => resentTab.link === tab.link)) {
            this.resentTabs.push(tab);
          }
        } else {
          tab.link = "/storage/" + item.storage_id;
          var storageExist = false;
          data.forEach((t, i) => {
            if (t.link == "/storage/" + item.storage_id) {
              storageExist = true;
            }
          });

          if (!storageExist) {
            this.activeTab = tab.link;
            this.$root.newStorageTab = tab;
            this.resentTabs.push(tab);
          }
        }

        this.$router.addRoutes([
          {
            path: "/storage/" + item.storage_id,
            component: Storage,
            name: "storage_" + item.storage_id,
            props: true
          }
        ]);
        id = item.storage_id;
        this.$router
          .push({
            path: tab.link,
            params: { id: id || item._id },
            name: "storage_" + item.storage_id
            // props: true,
          })
          .catch(err => {
            // ignore the vuex err regarding duplicate route entries
            if (err.name !== "NavigationDuplicated") {
              // handle other errors
            }
          });
      } else if (item.employee_id) {
        tab.employee_id = item.employee_id;
        tab.text = "Employee";

        tab.link = "/employee/" + item._id;

        if (!this.resentTabs.some(resentTab => resentTab.link === tab.link)) {
          this.resentTabs.push(tab);
        }
        this.activeTab = tab.link;

        this.$router.addRoutes([
          {
            path: "/employee/:id",
            component: Employee,
            name: "employee_" + item.full_name,
            props: true
          }
        ]);
        this.$router
          .push({
            path: tab.link,
            params: { id: item._id || id },
            name: "employee_" + item.full_name
            // props: true,
          })
          .catch(err => {
            // ignore the vuex err regarding duplicate route entries
            if (err.name !== "NavigationDuplicated") {
              // handle other errors
            }
          });
      } else if (item.report_name) {
        tab.storage_id = item.storage_id;

        var reportExist = false;
        data.forEach((t, i) => {
          if (t.link == "/report/" + item._id + "/" + item.report_type) {
            reportExist = true;
          }
        });

        if (!reportExist) {
          tab.text = item.report_name;

          tab.link = "/report/" + item._id;
          this.activeTab = tab.link;
          this.$root.newReportTab = tab;
          this.resentTabs.push(tab);
        }
        var linkName = "report_" + item._id;
        this.$router.addRoutes([
          {
            path: tab.link,
            component: Report,
            name: linkName,
            props: true
          }
        ]);

        this.$router
          .push({
            path: tab.link,
            params: { id: item._id },
            name: linkName
            // props: true,
          })
          .catch(err => {
            // ignore the vuex err regarding duplicate route entries
            if (err.name !== "NavigationDuplicated") {
              // handle other errors
            }
          });
      } else if (item.customer_id) {
        tab.text = item.text;
        tab.link = item.link;
        tab.icon = item.icon;
        this.activeTab = tab.link;

        this.$router.addRoutes([
          {
            path: "/customers/:id",
            component: Customers,
            name: "customer_" + item.text,
            props: true
          }
        ]);
        this.$router
          .push({
            path: item.link,
            params: { id: item.customer_id },
            name: "customer_" + item.text
            // props: true,
          })
          .catch(err => {
            // ignore the vuex err regarding duplicate route entries
            if (err.name !== "NavigationDuplicated") {
              // handle other errors
            }
          });
      } else if (item.ship_id) {
        tab.text = item.text;
        tab.link = item.link;
        tab.icon = item.icon;
        // this.activeTab = tab.link;
        this.$nextTick(() => {
          this.activeTab = tab.link;
        });

        this.$router.addRoutes([
          {
            path: "/intrnational-shipments/:id",
            component: InternationalShipments,
            name: "ship_" + item.text,
            props: true
          }
        ]);
        this.$router
          .push({
            path: item.link,
            params: { id: item.ship_id },
            name: "ship_" + item.text
            // props: true,
          })
          .catch(err => {
            // ignore the vuex err regarding duplicate route entries
            if (err.name !== "NavigationDuplicated") {
              // handle other errors
            }
          });
      } else {
        tab.text = item.text;
        tab.link = item.link;
        tab.icon = item.icon;

        if (item.link == "shipment") {
          var routeName = "shipment";
          this.$router.addRoutes([
            {
              path: item.link,
              component: Shipment,
              name: routeName,
              props: true
            }
          ]);
          this.$router
            .push({
              path: item.link,
              // params: { id: item.customer_id },
              name: routeName
              // props: true,
            })
            .catch(err => {
              // ignore the vuex err regarding duplicate route entries
              if (err.name !== "NavigationDuplicated") {
                // handle other errors
              }
            });
        }
        this.$nextTick(() => {
          this.activeTab = tab.link;
        });
        if (item.link == "shipment") {
          this.newShipmentTab = tab;
        }
      }

      tab.show = true;
      var exist = false;

      data.forEach(function(s) {
        if ((s && s.link == item.link) || !item.link) {
          exist = true;
        }
      });

      if (!exist) {
        data.push(tab);
        this.resentTabs = data;
        // this.menuKey = !this.menuKey;
      } else {
        // this.$router.push(item.link);
        if (!exist) {
          data.push(tab);
          this.resentTabs = data;

          // this.menuKey = !this.menuKey;
        }
        // this.resentTabs.forEach((t) => {
        //   if (this.$router.history.current.name == t.link) {
        //     exist = true;
        //   }
        // });
        // if (!exist) {
        //   data.push(tab);
        // }
        // this.$router.currentRoute = item;
        // console.log(this.resentTabs);
      }
      this.$root.$emit("tabAdded", item);
    },
    reloadCurrentTab() {
      // Find the current active tab from resentTabs
      const currentTab = this.resentTabs.find(t => t.link === this.activeTab);

      if (currentTab) {
        // Remove it temporarily
        const index = this.resentTabs.indexOf(currentTab);
        this.resentTabs.splice(index, 1);

        // Re-add it after a short delay
        this.$nextTick(() => {
          this.addResentTab(currentTab);
          this.$toast?.info("Form reloaded.");
        });
      } else {
        // fallback: reload route if no tab found
        this.$router.go();
      }
    },
    removeResentTab(tabToRemove, newIndex) {
      // this.resentTabs = this.resentTabs.filter(
      //   resetTab => resetTab.link !== tabToRemove.link
      // );
      // setTimeout(document.getElementsByClassName("tab-title")[0].click(), 5000);
      this.$root.newShipmentTab = null;
      this.$root.newStorageTab = null;
      this.$root.newReportTab = null;
      if (this.resentTabs[tabToRemove].shipment_id) {
        this.addToOpenShipments(this.resentTabs[tabToRemove].shipment_id, true);
      }
      this.tabToRemove = this.resentTabs[tabToRemove].link;
      this.resentTabs.splice(tabToRemove, 1);
      // if (this.resentTabs.length > 1) {
      //   this.lastTabIndex = this.resentTabs.length - 2;
      if (this.resentTabs.length) {
        if (newIndex) {
          this.activeTab = this.resentTabs[newIndex].link;
        } else {
          if (this.resentTabs[tabToRemove - 1]) {
            this.activeTab = this.resentTabs[tabToRemove - 1].link;
          }
        }
      } else {
        this.$router.push({ path: "/" }).catch(err => {
          // ignore the vuex err regarding duplicate route entries
          if (err.name !== "NavigationDuplicated") {
            // handle other errors
          }
        });
      }

      //   // this.addResentTab(this.resentTabs[this.lastTabIndex]);
      //   // this.activeTab = lastTabIndex;
      //   // var t = this.resentTabs[this.activeTab];

      //   // this.refreshTab(t);
      // }
      // this.resentTabs = this.resentTabs.filter(
      //   (resetTab) => resetTab.link !== tabToRemove.link
      // );
      this.remove = true;

      // this.$router.replace(tabToRemove.link);
    },
    logout() {
      // if (localStorage.getItem("createAccount")) {
      //   return;
      // }
      this.resentTabs = [];
      this.$root.resentTabs = [];
      this.$store.dispatch("auth/LOGOUT").then(() => {
        this.isAuthenticated = false;
        var portalId = this.store.portalData ? this.store.portalData.portal_id : "";
        var newURL = "/login/" + portalId;
        this.$router.push(newURL);
        this.$router.go({
          path: newURL
        });
      });
      if (this.store.userData) {
        var data = {
          metadata: {
            object_name: this.store.userData.type
          },
          model: {
            _id: this.store.userData._id.$oid,
            last_login_action: "logout",
            last_login_action_time: fun.formatDate(new Date(), false, true, true, false, true)
          }
          // model: {
          //   email: this.store.userData.email,
          //   action: "logout",
          //   time_stamp: fun.formatDate(
          //     new Date(),
          //     false,
          //     true,
          //     false,
          //     false,
          //     true
          //   ),
          // },
        };

        axios.post(this.serverURL + "/add_data", data, {
          withCredentials: true
        });
      }
    },
    calculatedHeight() {
      this.$nextTick(() => {
        if (this.$refs.router_view) {
          try {
            return window.innerHeight - this.$refs.router_view.$el.getBoundingClientRect().top + "px";
          } catch (error) {
            return "80vh";
          }
        }
        return "80vh";
      });
    },
    toHost() {
      this.$store.dispatch("auth/CHANGE_PORTAL", 1).then(() => this.$router.push("/"));
    },
    checkAllowedRoutes() {
      // const isFile = /\.(txt)$/i.test(this.$route.path);
      // if (this.$route.path == "/") {
      //   return;
      //   // } else {
      //   //   console.log(`${path} is not a path to a file.`);
      // }
      // var permissions = JSON.parse(localStorage.getItem("permittedKeys") || []);
      // if (this.$route.path.includes("login")) {
      //   window.location.href = "#" + this.$route.path;
      //   return true;
      // }
      if (!localStorage || localStorage.getItem("createAccount")) {
        return;
      }
      var menuItems = JSON.parse(localStorage.getItem("menuItems") || []);
      // var routes = this.$router.options.routes;
      var permitted = fun.getObjects(menuItems, "permitted", true);
      var isPermitted = permitted.filter(p => {
        return p.link == this.$route.path;
      }).length;
      var shipmentViewPermitted = permitted.filter(p => {
        return p.link == "/shipments";
      }).length;
      var storageViewPermitted = permitted.filter(p => {
        return p.link == "/storage";
      }).length;
      var reportViewPermitted = permitted.filter(p => {
        return p.link == "/reports";
      }).length;
      if (
        !isPermitted &&
        !this.$route.path.includes("/shipment/") &&
        !shipmentViewPermitted &&
        !this.$route.path.includes("/storage/") &&
        !storageViewPermitted &&
        !this.$route.path.includes("/report/") &&
        !reportViewPermitted
      ) {
        if (this.store.userData && permitted && permitted[0].link != this.$router.currentRoute.path) {
          this.$router.push({ path: permitted[0].link });
        }
      } else {
        if (this.$route.path != this.$router.currentRoute.path) {
          this.$router.push({ path: this.$route.path });
        } else {
          // this.$router.go(0);
        }
      }
      localStorage.setItem("loginTime", new Date());
    }
  },
  computed: {
    excludeRoutes() {
      // Exclude caching for the '/shipment/0' route only
      return this.$route.fullPath === "/shipment/0" ? ["Shipment"] : [];
    },

    isAuthenticated: function() {
      // return true
      return this.$store.state.auth.isAuthenticated;
    },
    isCustomerAuthenticated: function() {
      // return true
      return this.$store.state.auth.isCustomerAuthenticated;
    },
    email: function() {
      return this.store.userData && this.store.userData.email ? this.store.userData.email : "Not set";
    },
    user_id: function() {
      if (this.store.userData) {
        return this.store.userData._id.$oid;
      } else {
        return "";
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
      // || this.$vuetify.breakpoint.smOnly;
    },
    checkExcludedRoutes() {
      return (
        this.$route.fullPath.toLowerCase().indexOf("customerdocument") != -1 ||
        this.$route.fullPath.toLowerCase().indexOf("aichat") != -1 ||
        this.$route.fullPath.toLowerCase().indexOf("customer-inventory") != -1 ||
        this.$route.fullPath.toLowerCase().indexOf("component-on-demand") != -1 ||
        this.$route.fullPath.toLowerCase().indexOf("lead-access") != -1 ||
        this.$route.fullPath.toLowerCase().indexOf("/q/") != -1
      );
      // return (
      //   this.$route.fullPath.toLowerCase().indexOf("aichat") == -1 ||
      //   this.$route.fullPath.toLowerCase().indexOf("customerdocument") == -1
      // );
    },
    isTablet() {
      // return this.$vuetify.breakpoint.xsOnly;
      return this.$vuetify.breakpoint.smOnly;
    },
    roles: function() {
      return this.store.userData && this.store.userData.roles ? this.store.userData.roles : [];
    },
    customerId: function() {
      return this.store.userData && this.store.userData.type == "customer" ? this.store.userData._id : null;
    },
    isAdmin() {
      return this.roles.some(role => role.toLowerCase() === "admin");
    }
  },
  watch: {
    darkMode(newVal) {
      this.$vuetify.theme.dark = newVal;
      this.$root.$emit("themeChanged");
    },
    $route: {
      handler: function(newValue, oldValue) {
        // if (newValue.fullPath == "/new-shipment") {
        //   this.$router.push({ path: "/shipment/0" });
        // }
        try {
          this.checkAllowedRoutes();
        } catch (error) {
          //
        }

        if (this.$route.name == "Customer Portal") {
          console.log(this.$route.params.id);
        } else {
          if (this.remove && newValue.fullPath == this.tabToRemove) {
            if (this.activeTab != "/shipment/0") {
              this.$router.push({ path: oldValue.fullPath });
            }

            this.remove = false;
          }
        }
        var t = {};
        if (newValue.name && newValue.name.toLowerCase() == "shipment") {
          t = { shipment_id: newValue.params.id || 0 };
        }
        this.$root.$emit("tabUpdated", newValue.params.id);
      },
      deep: true,
      immediate: true
    },
    activeTab: {
      handler: function(newValue, oldValue) {
        // this.$route.path = newValue;

        if (this.remove) {
          this.$router.push({ path: newValue }).catch(err => {
            // ignore the vuex err regarding duplicate route entries
            if (err.name !== "NavigationDuplicated") {
              // handle other errors
            }
          });
        }
        this.$root.$emit("activeTabChanged");
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style>
html,
body {
  overscroll-behavior-x: none;
}

* {
  -ms-scroll-chaining: none;
}

:root {
  --edit-dialog-left: 300px;
}

.main {
  /* background-color: #c8ebfb !important; */
}

/* header {
  max-width: 90%;
  overflow-x: hidden !important;
} */

.full-screen {
  position: fixed;
  padding: 20px;
  top: 70px;
  left: 0;
  width: 100%;
  height: 90vh;
  overflow: auto;
  z-index: 10;
  background-color: white;
}
.circle-num {
  width: 28px;
  height: 28px;
  background: #1976d2; /* any color */
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
}

.v-application {
  /* background-color: rgb(8, 147, 206) !important; */
}

.left-menu {
  /* width: 35vh !important; */
  /* height: 100% !important; */
  /* background-color: rgb(8, 147, 206) !important; */
}

.theme--light.menu-drawer {
  /* background-color: rgb(236, 238, 239) !important; */
  /* color: white !important; */
}

.theme--light.ai-drawer {
  /* color: white !important; */
  border: dotted 1px;
  /* background-color: rgb(236, 238, 239) !important; */
}

.menu-drawer {
}

.ai-drawer {
  top: 0 !important;
  height: 100vh !important;
  max-height: 100vh !important;
  overflow: hidden !important;
  /* width: 400px !important; */
}

* {
  box-sizing: border-box;
}

.theme--light.v-sheet {
  /* background-color: white !important; */
  /* height: 75px !important; */
}

.gradient-background {
  background: linear-gradient(
    to bottom,
    rgba(220, 225, 230, 0.55) 0%,
    /* gentle silver top */ rgba(235, 240, 245, 0.3) 15%,
    /* lighter blend */ rgba(245, 248, 250, 0.15) 40%,
    /* soft fade */ rgba(252, 253, 255, 0.08) 70%,
    /* nearly white */ rgba(255, 255, 255, 0.98) 100% /* white bottom */
  );
}

.theme--dark .gradient-background {
  background: linear-gradient(
    to bottom,
    rgba(35, 40, 45, 0.98) 0%,
    /* near-black top */ rgba(32, 36, 42, 0.7) 15%,
    /* dark blend */ rgba(28, 32, 38, 0.4) 40%,
    /* soft fade */ rgba(22, 26, 31, 0.18) 70%,
    /* near-transparent */ rgba(18, 20, 24, 0.08) 100% /* deep black bottom */
  );
}
/* ================================
   GLOBAL V-TABS — LIGHT MODE
================================ */

.v-tabs {
  min-height: 32px;
}

.v-tabs-bar {
  background: transparent;
  border-bottom: 1px solid #e6edf5;
}

/* individual tab */
.v-tab {
  min-height: 32px;
  padding: 0 10px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.01em;
  color: #7a8796;
}

/* hover */
.v-tab:hover {
  color: #2c3e50;
}

/* active tab */
.v-tab.v-tab--active {
  color: #2c3e50;
  font-weight: 600;
}

/* tab indicator */
.v-tabs-slider {
  height: 2px;
  background-color: #4a90e2;
}
/* ================================
   GLOBAL V-TABS — DARK MODE
================================ */

.theme--dark .v-tabs {
  min-height: 32px;
}

.theme--dark .v-tabs-bar {
  background: transparent;
  border-bottom: 1px solid #2a3442;
}

/* individual tab */
.theme--dark .v-tab {
  min-height: 32px;
  padding: 0 10px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.01em;
  color: #9aa6b2;
}

/* hover */
.theme--dark .v-tab:hover {
  color: #e3e9f1;
}

/* active tab */
.theme--dark .v-tab.v-tab--active {
  color: #e3e9f1;
  font-weight: 600;
}

/* tab indicator */
.theme--dark .v-tabs-slider {
  height: 2px;
  background-color: #6aa9ff;
}

.page-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.v-snack.multi {
  height: initial !important;
  /* width: initial !important; */
  /* position: initial !important; */
}

input::placeholder {
  color: green;
}

textarea {
  margin-top: 10px !important;
  padding: 10px !important;
  border: solid 1px gainsboro !important;
}

.left-menu {
  z-index: 100 !important;
  /* background-color: rgb(8, 147, 206) !important; */
  /* background-color: #c8ebfb !important; */
  /* height: 100% !important; */
}

.alert {
  position: fixed !important;
  margin: 0 2vw !important;
  width: 96vw !important;
  bottom: 3vh !important;
  z-index: 7 !important;
  opacity: 1 !important;
}

table {
  border-collapse: collapse !important;
}

th {
  white-space: nowrap !important;
}

.underscore {
  text-decoration: underline;
  /* color: rgb(117, 155, 224); */
}

.colored .underscore {
  color: white;
  text-decoration: underline;
}

.colored .router-link-active div {
  color: white !important;
  text-decoration: underline;
}

.pointer {
  cursor: pointer;
}
.main-tabs .v-tab--active {
  background-color: rgb(232, 235, 237);
  /* z-index: 100; */

  color: black !important;
  border-radius: 10px 10px 0 0;
  border: solid 3px rgba(235, 240, 245, 1);
  /* border-left: solid 1px #24aaec;
  border-right: solid 1px #24aaec; */
}
.active-view {
  border: solid 3px rgba(235, 240, 245, 1);
  /* background-color: rgba(235, 240, 245, 1); */
  border-radius: 10px;
  padding: 20px;
}
.v-tabs-slider {
  display: none !important;
}

.card-outter {
  /* position: relative; */
  height: 100%;
  padding-bottom: 50px;
}

.card-actions {
  /* position: fixed; */
  /* bottom: 0; */
  margin: 0 auto;
  /* left: 50%; */
  /* width: 100%; */
  /* max-width: 500px; */
  /* background-color: lightgray; */
  /* transform: translateX(-50%); */
  /* right: 0; */
}

.v-fade {
  display: inherit !important;
  /* override v-show display: none */
  transition: opacity 0.5s;
}

.v-fade[style*="display: none;"] {
  opacity: 0;
  pointer-events: none;
  /* disable user interaction */
  user-select: none;
  /* disable user selection */
}

/* .row-pointer >>> tbody tr :hover {
  cursor: pointer;
} */
.row-pointer {
  width: 100%;
}

.row-pointer >>> tbody tr td {
  white-space: nowrap !important;
}

th >>> thead tr {
  white-space: nowrap !important;
}

/* .drag-handle {
  cursor: pointer;
} */

.ghost {
  opacity: 0.5;
  /* background: #c8ebfb; */
}

.drag-header {
  cursor: move;
}

.v-main {
  /* padding: 32px 0px 0px 256px !important; */
}

.v-main__wrap {
  /* background-color: rgb(230, 236, 244); */
}

.v-toolbar,
.v-toolbar__content {
  /* height: initial !important; */
}

.v-card__text {
  padding-bottom: 36px !important;
}
.v-navigation-drawer__content {
  /* background-color: rgb(5, 139, 196) !important; */
}
.theme--dark .v-navigation-drawer__content {
  /* background-color: rgb(5, 139, 196) !important; */
  /* height: 100%; */
}

.left-menu .theme--dark.v-icon {
  /* color: #ffffff !important; */
}
/* ================================
   LEFT MENU / NAVIGATION DRAWER
   LIGHT MODE
================================ */
.v-navigation-drawer {
  max-height: 100% !important;
  overflow-y: auto;
}
.v-navigation-drawer__content {
  background: linear-gradient(
    to bottom,
    rgba(245, 248, 252, 0.95) 0%,
    rgba(240, 244, 249, 0.9) 40%,
    rgba(235, 240, 245, 0.85) 100%
  );
  color: #2c3e50;
  border-right: 1px solid #e6edf5;
  max-height: 93% !important;
  overflow-y: auto;
}
.theme--dark .v-navigation-drawer__content {
  background: linear-gradient(
    to bottom,
    rgba(34, 40, 48, 0.98) 0%,
    rgba(30, 35, 42, 0.95) 40%,
    rgba(26, 30, 36, 0.92) 100%
  );
  color: #e3e9f1;
  border-right: 1px solid #2a3442;
}

/* drawer content */
.v-navigation-drawer__content {
  padding: 8px 0;
}

/* list container */
.v-navigation-drawer .v-list {
  background: transparent;
  padding: 0;
}

/* list item */
.v-navigation-drawer .v-list-item {
  min-height: 36px;
  padding: 0 12px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7c93;
  border-radius: 6px;
  margin: 2px 6px;
  transition: background-color 0.12s ease, color 0.12s ease;
}

/* list item icon */
.v-navigation-drawer .v-list-item .v-icon {
  font-size: 22px;
  margin-right: 10px;
  /* color: #9aa6b2; */
}

/* hover */
.v-navigation-drawer .v-list-item:hover {
  background-color: #eef3f9;
  color: #2c3e50;
}

.v-navigation-drawer .v-list-item:hover .v-icon {
  color: #4a90e2;
}

/* active item */
.v-navigation-drawer .v-list-item--active {
  background-color: rgba(74, 144, 226, 0.12);
  color: #2c3e50;
  font-weight: 600;
}

.v-navigation-drawer .v-list-item--active .v-icon {
  color: #4a90e2;
}
.demo-highlight {
  position: relative;
  z-index: 10;
  box-shadow: 0 0 0 3px #1976d2;
  border-radius: 6px;
  animation: demoPulse 1s infinite;
}

@keyframes demoPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
}
/* section headers (if any) */
.v-navigation-drawer .v-subheader {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9aa6b2;
  padding: 10px 16px 4px;
}

/* ================================
   LEFT MENU / NAVIGATION DRAWER
   DARK MODE
================================ */

.theme--dark .v-navigation-drawer {
  background-color: #1f252c;
  color: #e3e9f1;
  border-right: 1px solid #2a3442;
}

/* drawer content */
.theme--dark .v-navigation-drawer__content {
  padding: 8px 0;
}

/* list */
.theme--dark .v-navigation-drawer .v-list {
  background: transparent;
}

/* list item */
.theme--dark .v-navigation-drawer .v-list-item {
  min-height: 36px;
  padding: 0 12px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #a6b0c0;
  border-radius: 6px;
  margin: 2px 6px;
  transition: background-color 0.12s ease, color 0.12s ease;
}

/* icon */
.theme--dark .v-navigation-drawer .v-list-item .v-icon {
  font-size: 22px;
  margin-right: 10px;
  color: #7f8fa3;
}

/* hover */
.theme--dark .v-navigation-drawer .v-list-item:hover {
  background-color: #232a33;
  color: #e3e9f1;
}

.theme--dark .v-navigation-drawer .v-list-item:hover .v-icon {
  color: #6aa9ff;
}

/* active */
.theme--dark .v-navigation-drawer .v-list-item--active {
  background-color: rgba(106, 169, 255, 0.18);
  color: #e3e9f1;
  font-weight: 600;
}

.theme--dark .v-navigation-drawer .v-list-item--active .v-icon {
  color: #6aa9ff;
}

/* section headers */
.theme--dark .v-navigation-drawer .v-subheader {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #7f8fa3;
  padding: 10px 16px 4px;
}

/* .v-menu__content  {
  z-index: 1000 !important;
} */
/* .menuable__content__active  {
  z-index: 10 !important;
} */

.vue-horizontal-timeline .timeline ol {
  padding: initial !important;
}

.vue-horizontal-timeline .timeline {
  margin-top: 3px;
  padding: 5em 0 !important;
  margin-left: 6px !important;
}

.vue-horizontal-timeline .timeline .title {
  margin: -5px !important;
  font-size: medium !important;
  /* padding-top: 10px !important; */
}

.vue-horizontal-timeline .timeline .content {
  margin: -5px !important;
  /* margin-top: 5px !important; */
  overflow: visible !important;
  padding-left: 0px !important;
  font-size: small !important;
}

/* .time {
  min-width: 350px !important;
} */
.v-tooltip__content {
  opacity: 1 !important;
  background: #615a5a;
}
@media only screen and (min-width: 600px) {
  .nav-blue {
    /* background-color: rgb(8, 147, 206) !important; */
    width: 288px;
  }
  .main-template {
    height: 80vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .version {
    background-color: transparent;
    /* color: rgb(241, 246, 146); */
    font-size: small;
    text-align: right;
    font-style: italic;
    font-weight: 700;
    position: fixed;
    bottom: 0px;
    left: 220px;
  }
}
.v-text-field input[type="number"] {
  min-width: 90px !important;
}
@media only screen and (max-width: 600px) {
  .v-input {
    max-width: 350px !important;
  }
  .v-application {
    overflow-x: hidden;
  }
  .version {
    /* font-weight: 10; */
    font-size: x-small;
    background-color: transparent;
    color: rgb(109, 68, 17);

    text-align: right;
    font-style: italic;
    font-weight: bold;
    position: fixed;
    bottom: 0px;
    left: 220px;
  }

  .nav-blue {
    width: 100%;
    /* background-color: "white" !important; */
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 100% !important;
  }
  .v-text-field input[type="number"] {
    max-width: 90px;
  }
}
</style>
